// protocol.ts
var MessageTypes = /* @__PURE__ */ ((MessageTypes2) => {
  MessageTypes2["GQL_START"] = "start";
  MessageTypes2["GQL_DATA"] = "data";
  MessageTypes2["GQL_ERROR"] = "error";
  MessageTypes2["GQL_STOP"] = "stop";
  MessageTypes2["GQL_COMPLETE"] = "complete";
  MessageTypes2["GQL_CONNECTION_INIT"] = "init";
  MessageTypes2["GQL_CONNECTION_ACK"] = "ack";
  MessageTypes2["GQL_CONNECTION_ERROR"] = "connection-error";
  MessageTypes2["GQL_CONNECTION_KEEP_ALIVE"] = "ka";
  MessageTypes2["GQL_CONNECTION_CLOSE"] = "close";
  MessageTypes2["GQL_CONNECTION_ACK_CLOSE"] = "kca";
  MessageTypes2["GQL_CONNECTION_TERMINATE"] = "terminate";
  return MessageTypes2;
})(MessageTypes || {});
export {
  MessageTypes
};
